import React from 'react';
import PropTypes from 'prop-types';
import {CenterWrapper, ProjectIndicatorLink, ProjectIndicatorNoLink} from './project_indicator.styled';

export const ProjectIndicator = ({
	htmlId,
	showOutline,
	customId,
	name,
	id,
	color,
	isConnectedProject,
	clearSubPath,
	noTitle,
	small,
	link,
	disableLink,
	noWidthLimit,
	project,
}) => {
	/*********************************************************************
	 This is web-front logic, should really not be here in web-components
	**********************************************************************/

	const getNavigationString = (project, clearSubPath) => {
		if (!project) return null;
		const curLocArr = window.location.href.split('/');
		const pageName = curLocArr[curLocArr.length - 1];
		if (project.companyProjectGroupId) {
			return (
				'/connected/X-' + project.companyProjectGroupId + '/' + (clearSubPath || pageName === 'my-list' ? '' : pageName)
			);
		}
		return '/project/P-' + project.companyProjectId + '/' + (clearSubPath || pageName === 'my-list' ? '' : pageName);
	};

	const getCustomTitle = (customId, name) => {
		return `${customId} - ${name}`;
	};

	const getOldTitle = () =>
		(project.companyProjectGroupId ? 'X' + project.companyProjectGroupId : 'P' + project.companyProjectId) +
		' - ' +
		project.name;

	const getNewTitle = () => {
		if (isConnectedProject) {
			return `X${id}`;
		} else {
			return `P${id} - ${name}`;
		}
	};

	const getOldIconText = connected => {
		return connected ? 'X' + project.companyProjectGroupId : 'P' + project.companyProjectId;
	};
	const getNewIconText = () => {
		return isConnectedProject ? `X${id}` : `P${id}`;
	};
	const isConnected = (project && project.companyProjectGroupId) || isConnectedProject;
	const title = customId ? getCustomTitle(customId, name) : project ? getOldTitle() : getNewTitle();
	const iconText = customId ? customId : project ? getOldIconText(isConnected) : getNewIconText();
	const href = disableLink ? null : link ? link : getNavigationString(project, clearSubPath);

	const ProjectIndicatorComponent = disableLink ? ProjectIndicatorNoLink : ProjectIndicatorLink;

	return isConnected ? (
		<ProjectIndicatorComponent
			id={htmlId}
			showOutline={showOutline}
			onClick={disableLink ? null : e => e.stopPropagation()}
			isDisabled={disableLink}
			href={href}
			title={noTitle ? '' : title}
			color={project ? project.projectColor || color : color}
			noWidthLimit={noWidthLimit}
			small={small}
		>
			<CenterWrapper>{iconText}</CenterWrapper>
		</ProjectIndicatorComponent>
	) : (
		<ProjectIndicatorComponent
			id={htmlId}
			showOutline={showOutline}
			onClick={disableLink ? null : e => e.stopPropagation()}
			isDisabled={disableLink}
			href={href}
			title={noTitle ? '' : title}
			color={project ? project.projectColor : color}
			noWidthLimit={noWidthLimit}
			small={small}
		>
			<CenterWrapper>
				<div data-cy="project-id">{iconText}</div>
			</CenterWrapper>
		</ProjectIndicatorComponent>
	);
};

ProjectIndicator.propTypes = {
	htmlId: PropTypes.string,
	showOutline: PropTypes.bool,
	customId: PropTypes.string,
	name: PropTypes.string,
	id: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
	color: PropTypes.string,
	isConnectedProject: PropTypes.bool,
	clearSubPath: PropTypes.bool,
	noTitle: PropTypes.bool,
	small: PropTypes.bool,
	link: PropTypes.string,
	disableLink: PropTypes.bool,
	noWidthLimit: PropTypes.bool,
	project: PropTypes.object,
};

ProjectIndicator.defaultProps = {
	clearSubPath: false,
};
